import { render } from "./PopupSendStatement.vue?vue&type=template&id=64f1a6cb"
import script from "./PopupSendStatement.vue?vue&type=script&lang=js"
export * from "./PopupSendStatement.vue?vue&type=script&lang=js"

import "./PopupSendStatement.vue?vue&type=style&index=0&id=64f1a6cb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__